import dayjs from 'dayjs';
import React from "react";
import Chart from "react-apexcharts";




const PriceChart = ({chartData, priceData}) => {
  const reversedChartData = [...chartData].reverse()
      const config = {
        options: {
          chart: {
            id: "basic-bar"
          },
          xaxis: {
            categories: reversedChartData.map((item) => dayjs(item.date).format('YY-MM-DD HH:mm'))
          },
          title: {
            text: `${priceData.commodity_name} price movements`,
            align: 'left'
          },
          subtitle: {
            text: priceData.grade,
            align: 'left'
          },
        },
        series: [
          {
            name: "prices",
            data: reversedChartData.map((item) => item?.new_price_per_kg)
          }
        ],
        fill: {
          type: "gradient",
          gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.7,
            opacityTo: 0.9,
            stops: [0, 90, 100]
          }
        },
      };

 return <Chart
            options={config.options}
            series={config.series}
            type="area"
            height={415}
          />
          
}

export default PriceChart